import type { IEmployeeRepository, EmployeeListQuery } from '@domain/data-contracts/employee-repository.interface';
import type { Employee } from '@domain/models/employee.interface';
import type { PagedResult } from '@domain/models/paging.interface';

export class EmployeesService {
  public constructor(private readonly repo: IEmployeeRepository) {}

  public list(query: EmployeeListQuery): Promise<PagedResult<Employee>> {
    return this.repo.list(query);
  }
}
